// Dune Analytics configuration
// Centralized configuration for easy maintenance and extensibility

export const CACHE_TTL_MINUTES = 5;
export const CACHE_TTL_MS = CACHE_TTL_MINUTES * 60 * 1000;

// Served by api/metrics.js, which reads Dune with a server-side key (DUNE_API_KEY in Vercel).
export const METRICS_URL = '/api/metrics';

// Protocol queries configuration. The browser no longer calls Dune: api/metrics.js holds the
// same ids and is the one that reads them. Keep both lists in sync.
export const DUNE_QUERIES = {
  soroswap: {
    TVL: { name: "TVL", queryId: 5771139 },
    accounts: { name: "accounts", queryId: 4346394 }
  },
  defindex: {
    TVL: { name: "TVL", queryId: 5926839 },
    accounts: { name: "accounts", queryId: 5576346 }
  }
};

// SWR configuration
export const SWR_CONFIG = {
  refreshInterval: CACHE_TTL_MS,
  revalidateOnFocus: false,
  revalidateOnReconnect: true,
  errorRetryCount: 3,
  errorRetryInterval: 30000, // 30 seconds
  dedupingInterval: 60000,   // 1 minute deduping
};

// Static fallback data - Based on actual Dune Analytics data
export const STATIC_FALLBACK_METRICS = {
  // Last updated from Dune on 2026-10-21
  soroswap: {
    TVL: { value: 57891802, formatted: "+ $57.8M" },
    accounts: { value: 4800, formatted: "+ 4.8K users" }
  },
  defindex: {
    TVL: { value: 19475400, formatted: "+ $19.4M" },
    accounts: { value: 28604, formatted: "+ 28.6K users" }
  }
};

// Metric types for extensibility
export const METRIC_TYPES = {
  TVL: 'TVL',
  ACCOUNTS: 'accounts'
};